import { toast } from 'react-toastify';
import { toastResponse } from '../../../helper components/Toast/Toast';
import lang from '../../../assets/i18n/en.json';
import Form from 'react-bootstrap/Form';
import { emailValidation, passwordValidation } from '../../../utils/Utils';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { Link, useNavigate } from 'react-router-dom';
import allImages from '../../../assets/images/allImages';
import { useDispatch } from 'react-redux';
import { loginAsync } from '../../../Redux/authSlice';
import { useMutation, useLazyQuery } from '@apollo/client';
import { EnterpriseLogin } from '../../../Mutations/MutationsUpdated';
import { GetEnterpriseUser } from '../../../Queries/QueriesUpdated';
import { client, httpLink } from '../../../apollo_server_connection';
import { ApolloLink, concat } from 'apollo-link';

export function Login() {
  const navigate = useNavigate();
  const PAGE = lang.PAGE;
  const ERROR = lang.ERROR;
  const [userDetails, setUserDetails] = useState({
    email: '',
    password: '',
  });
  const [errors, setError] = useState({
    email: false,
    emailError: '',
    password: false,
    passwordError: '',
  });
  const [passwordToggle, setPasswordToggle] = useState(true);
  const dispatch = useDispatch();
  const [loginResponse, isLoginResponse] = useState();

  const [login, { loading }] = useMutation(EnterpriseLogin, {
    onCompleted: (data) => {
      isLoginResponse(data);
    },
    onError: ({ graphQLErrors }) => {
      if (graphQLErrors[0].extensions.response) {
        if (graphQLErrors[0].extensions.response.statusText === 'Unauthorized')
          // Check if any of the GraphQL errors have a 401 status code
          toast.error(
            toastResponse('error', ERROR.CUSTOM.CODE.ERROR_USER_ROLE_NOT_EXIST),
          );
      } else {
        toast.error(toastResponse('error', graphQLErrors[0].message));
      }
    },
  });

  const [fetchUser, { data: userData, loading: loadingGet }] =
    useLazyQuery(GetEnterpriseUser);

  useEffect(() => {
    if (loginResponse && !userData) {
      const token =
        loginResponse.enterpriseLogin.loginResponse.standardToken.accessToken;
      // Update the headers of the Apollo Client instance
      client.setLink(
        concat(
          new ApolloLink((operation, forward) => {
            operation.setContext({
              headers: {
                authorization: token ? `Bearer ${token}` : '',
              },
            });
            return forward(operation);
          }),
          httpLink,
        ),
      );
      fetchUser();
    }
    if (loginResponse && userData) {
      // Dispatch the async action using redux-thunk
      console.log('test',loginResponse, userData )
      dispatch(
        loginAsync({
          enterpriseLogin: loginResponse.enterpriseLogin,
          userData: userData.getEnterpriseUser,
        }),
      );
      if (userData.getEnterpriseUser.role === 'BOND_ADMIN') {
        navigate('/enterprise/bond-admin/dashboard');
      } else if (userData.getEnterpriseUser.role === 'ENTERPRISE_ADMIN') {
        navigate('/enterprise/enterprise-admin/dashboard');
      } else {
        navigate('/');
      }
    }
  }, [loginResponse, userData, fetchUser, dispatch, navigate]);

  const onSubmit = () => {
    try {
      //Call mutaion with parameter
      login({
        variables: { email: userDetails.email, password: userDetails.password },
      });
    } catch (error) {
      toast.error(toastResponse('error', error));
    }
  };
  return (
    <>
      <div className="pageBlock">
        <div className="pb-5">
          <h3 className="login-registration-form pageTitle fw-bolder text-dark display-6 shrinkTitle">
            Login{' '}
          </h3>
          {/* <h3 className='loginRegisterBlock subTitle'>Need an account?<Link to='/user/register' className="theme link fw-bolder ms-1" tabIndex="0">
                  Signup</Link></h3> */}
        </div>
        <form>
          <div className=" mb-6">
            <Form.Label className="loginRegisterBlock label text-dark">
              {PAGE.AUTH.SIGNIN.USERNAME.LABEL}
            </Form.Label>
            <Form.Control
              type="email"
              className="form-control form-control-lg form-control-solid"
              isInvalid={errors.email}
              onChange={(e) => {
                setUserDetails((userDetails) => ({
                  ...userDetails,
                  email: e.target.value,
                }));
                emailValidation(e.target.value, errors, setError);
              }}
            />
            <Form.Control.Feedback
              type="invalid"
              style={{
                color: 'red',
                fontSize: '0.875em',
                marginTop: '0.25rem',
              }}
            >
              {errors.emailError}
            </Form.Control.Feedback>
          </div>
          <div className="mb-6">
            <Form.Label className="loginRegisterBlock label text-dark">
              {PAGE.AUTH.SIGNIN.PASSWORD.LABEL}
            </Form.Label>
            <div className="position-relative">
              <Form.Control
                type={passwordToggle ? 'password' : 'text'}
                className="form-control form-control-lg form-control-solid "
                isInvalid={errors.password}
                onChange={(e) => {
                  setUserDetails((userDetails) => ({
                    ...userDetails,
                    password: e.target.value,
                  }));
                  passwordValidation(e.target.value, errors, setError);
                }}
              />
              <div className="showPasswordBlock">
                <img
                  src={allImages.showPwd}
                  className="container-fluid"
                  style={{ display: !passwordToggle ? 'block' : 'none' }}
                  onClick={(e) => {
                    setPasswordToggle((passwordToggle) => !passwordToggle);
                  }}
                  alt="show_password_icon"
                />
                <img
                  src={allImages.hidePwd}
                  className="container-fluid"
                  style={{ display: passwordToggle ? 'block' : 'none' }}
                  onClick={(e) =>
                    setPasswordToggle((passwordToggle) => !passwordToggle)
                  }
                  alt="hide_password_icon"
                />
              </div>
            </div>
            <Form.Control.Feedback
              type="required"
              style={{
                color: 'red',
                fontSize: '0.875em',
                marginTop: '0.25rem',
              }}
            >
              {errors.passwordError}
            </Form.Control.Feedback>
          </div>
          <div className="mb-2">
            <Link to="/user/forgot" className="theme link float-end fw-bolder">
              {PAGE.AUTH.SIGNIN.FORGOT_PASSWORD.LABEL}
            </Link>
          </div>
          <div className="mt-12">
            <Button
              className="theme btn btn-primary me-6"
              type="submit"
              disabled={!(userDetails.email && userDetails.password)}
              onClick={(e) => {
                e.preventDefault();
                onSubmit();
              }}
            >
              Sign In{' '}
              {(loading || loadingGet) && (
                <i
                  className="spinner-grow spinner-grow-sm ms-3"
                  role="status"
                />
              )}
            </Button>
          </div>
        </form>
      </div>
    </>
  );
}
